import Breadcrumb from "@/common/Breadcrumb";
import HeaderOne from "@/layouts/headers/HeaderOne";
import Wrapper from "@/layouts/Wrapper";
import CtaHomeOne from "../homes/home-1/CtaHomeOne";
import FooterOne from "@/layouts/footers/FooterOne";
import ProjectsArea from "./ProjectsArea";
import { useI18n } from "@/common/I18nProvider";

export default function Projects() {
  const { messages } = useI18n();
  const projects = messages.projects;

  return (
    <Wrapper>
      <HeaderOne />
      <div id="smooth-wrapper">
        <div id="smooth-content">
          <Breadcrumb title={projects.subtitle} pageLink={projects.subtitle} />
          <ProjectsArea />                           
          <CtaHomeOne />
          <FooterOne />
        </div>
      </div>
    </Wrapper>
  )
}
